import {
  borderRadius,
  Drawer,
  Dropdown,
  DropdownProps,
  typographyV2,
} from '@toggle/design-system';
import { FC } from 'react';
import styled from 'styled-components';

import { ChatInput } from '~/components/chat-input/ChatInput';
import { ChatSubmit } from '~/components/chat-submit/ChatSubmit';
import { TagSubmit } from '~/components/tag-submit/TagSubmit';
import { Messages } from '~/views/intel/messages/Messages';

export const Root = styled.div`
  height: 100%;
`;

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Container} {
    width: 600px;
  }
`;

export const MessagesWrapper = styled.div`
  padding: 0 16px 140px 16px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80%;
  margin: 0 16px;
`;

export const Title = styled.p`
  ${typographyV2.titleLg};
  margin: 8px 0 4px 0;
`;

export const Text = styled.p`
  ${typographyV2.bodyBase};
  margin-bottom: 60px;
`;

export const ChatFooterWrapper = styled.section`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  bottom: 16px;
  left: 16px;
  z-index: 1;
  border: 1px solid var(--border-soft);
  border-radius: 16px;

  ${ChatInput.Styled.ChatInputWrapper} {
    border: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  ${Dropdown.Styled.Container} {
    margin: 0;
  }

  ${TagSubmit.Styled.Form} {
    width: 568px;
    padding: 0;
  }
`;

export const StyledChatSubmit = styled(ChatSubmit)`
  width: 568px;
  padding: 0;
`;

export const QuestionContainer = styled.div`
  width: 100%;
`;

export const QuestionsHeader = styled.p`
  text-align: center;
  color: var(--text-soft);
  ${typographyV2.titleSm};
  margin-bottom: 12px;
`;
export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledMessages = styled(Messages)`
  margin: 0 16px;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  width: fit-content;
  padding-left: 16px;
`;

export const StyledButton = styled.button`
  ${borderRadius.r1};
  color: var(--text-default);
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  white-space: nowrap;
  border: none;
`;

export const ButtonText = styled.span`
  ${typographyV2.bodySm};
`;

export const StyledDropdown = styled<FC<DropdownProps<string>>>(Dropdown)`
  background: var(--background-soft);
  margin-top: -20px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;
